import { Component, Input, inject } from '@angular/core';
import { ClientChore } from 'app/core/models/client-chore.model';
import { DownloadService } from 'app/core/services/download.service';
import { ClientChoresService } from 'app/core/services/client-chores.service';
import { DecimalPipe, KeyValuePipe } from '@angular/common';
import { SimpleExpandableAreaComponent } from '../../../shared/components/simple-expandable-area/simple-expandable-area.component';
import { ClientChoreStatusComponent } from '../client-chore-status/client-chore-status.component';
import { ClientChoreReviewComponent } from '../client-chore-review/client-chore-review.component';
import { ClientChoreLifecycleComponent } from '../client-chore-lifecycle/client-chore-lifecycle.component';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';
import { CaptureStatusesAndReasonsPipe } from 'app/shared/pipes/capture-statuses-and-reasons.pipe';

@Component({
    selector: 'app-client-chore-list',
    templateUrl: './client-chore-list.component.html',
    styleUrls: ['./client-chore-list.component.scss'],
    imports: [SimpleExpandableAreaComponent,
              ClientChoreStatusComponent,
              ClientChoreReviewComponent,
              ClientChoreLifecycleComponent,
              DecimalPipe,
              KeyValuePipe,
              BlankValueDashPipe,
              CaptureStatusesAndReasonsPipe]
})
export class ClientChoreListComponent {
  private clientChoresService = inject(ClientChoresService);
  private downloadService = inject(DownloadService);

  @Input() clientChores: ClientChore[] = [];
  @Input() canManageChores = false;

  onDownloadClick($event: MouseEvent, expirableDownloadPath: string) {
    $event.preventDefault();
    this.downloadService.getDownloadUrl(expirableDownloadPath).subscribe(expirableDownload => {
      this.downloadService.download(expirableDownload.url);
    });
  }

  onFailClick($event: MouseEvent, clientChoreId: number) {
    $event.preventDefault();

    if (confirm("Are you sure you want to fail this chore?  Records may be left in an invalid state.")) {
      this.clientChoresService
        .fail(clientChoreId)
        .subscribe((updatedClientChore) => {
          this.replaceUpdatedClientChore(updatedClientChore);
        });
    }
  }

  onRestartClick($event: MouseEvent, clientChoreId: number) {
    $event.preventDefault();

    this.clientChoresService
      .restart(clientChoreId)
      .subscribe((updatedClientChore) => {
        this.replaceUpdatedClientChore(updatedClientChore);
      });
  }

  onReviewChange($event: boolean, clientChore: ClientChore) {
    clientChore.reviewed = $event;

    this.clientChoresService
      .review(clientChore.id, clientChore.reviewed)
      .subscribe((updatedClientChore) => {
        this.replaceUpdatedClientChore(updatedClientChore);
      });
  }

  private replaceUpdatedClientChore(updatedClientChore: ClientChore) {
    const index = this.clientChores.findIndex(chore => chore.id === updatedClientChore.id);

    if (index > -1) {
      this.clientChores[index] = updatedClientChore;
    }
  }
}
